<div class="inspections">
  <p class="main-case">להלן תוצאות הבדיקה לפי ת"י 2206 חלק 2:</p>

  <table class="data-table">
    <thead>
      <tr>
        <th style="width: 10%">
          <strong>הסעיף התקן</strong>
        </th>
        <th style="width: 43%">
          <strong>תיאור הסעיף</strong>
        </th>
        <th style="width: 37%">
          <strong>הערות</strong>
        </th>
        <th style="width: 10%">
          <strong>מסקנה</strong>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr class="section">
        <td><span>--</span></td>
        <td><span>תיאור כללי</span></td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td class="section">
          <span>{{ inspection?.waterSupplyAccordingTable4.section }}</span>
        </td>
        <td>
          <span>{{ inspection?.waterSupplyAccordingTable4?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.waterSupplyAccordingTable4?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(inspection?.waterSupplyAccordingTable4)
          }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{ inspection?.riskPerceptionMeetStandard.section }}</span>
        </td>
        <td>
          <span>{{ inspection?.riskPerceptionMeetStandard?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.riskPerceptionMeetStandard?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(inspection?.riskPerceptionMeetStandard)
          }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{ inspection?.waterSupplyPipeDiameter.section }}</span>
        </td>
        <td>
          <span>{{ inspection?.waterSupplyPipeDiameter?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.waterSupplyPipeDiameter?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{ getConclusion(inspection?.waterSupplyPipeDiameter) }}</span>
        </td>
      </tr>
      <tr>
        <td class="section"></td>
        <td>
          <span>{{ inspection?.pumpDetails?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.pumpDetails?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{ getConclusion(inspection?.pumpDetails) }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{ inspection?.pumpCommandBoard.section }}</span>
        </td>
        <td>
          <span>{{ inspection?.pumpCommandBoard?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.pumpCommandBoard?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{ getConclusion(inspection?.pumpCommandBoard) }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{ inspection?.pumpCannotStop.section }}</span>
        </td>
        <td>
          <span>{{ inspection?.pumpCannotStop?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.pumpCannotStop?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{ getConclusion(inspection?.pumpCannotStop) }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{ inspection?.tapsLocked.section }}</span>
        </td>
        <td>
          <span>{{ inspection?.tapsLocked?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.tapsLocked?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{ getConclusion(inspection?.tapsLocked) }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{ inspection?.tapsMarked.section }}</span>
        </td>
        <td>
          <span>{{ inspection?.tapsMarked?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.tapsMarked?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{ getConclusion(inspection?.tapsMarked) }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{ inspection?.waterSupplyTapAndRollerInterval.section }}</span>
        </td>
        <td>
          <span>{{ inspection?.waterSupplyTapAndRollerInterval?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.waterSupplyTapAndRollerInterval?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{
            getConclusion(inspection?.waterSupplyTapAndRollerInterval)
          }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{ inspection?.a_4_4_2.section }}</span>
        </td>
        <td>
          <span>{{ inspection?.a_4_4_2?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.a_4_4_2?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{ getConclusion(inspection?.a_4_4_2) }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{ inspection?.a_5_3_2.section }}</span>
        </td>
        <td>
          <span>{{ inspection?.a_5_3_2?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.a_5_3_2?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{ getConclusion(inspection?.a_5_3_2) }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{ inspection?.a_5_6.section }}</span>
        </td>
        <td>
          <span>{{ inspection?.a_5_6?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.a_5_6?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{ getConclusion(inspection?.a_5_6) }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{ inspection?.a_5_7.section }}</span>
        </td>
        <td>
          <span>{{ inspection?.a_5_7?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.a_5_7?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{ getConclusion(inspection?.a_5_7) }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{ inspection?.a_5_8.section }}</span>
        </td>
        <td>
          <span>{{ inspection?.a_5_8?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.a_5_8?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{ getConclusion(inspection?.a_5_8) }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{ inspection?.a_6_1.section }}</span>
        </td>
        <td>
          <span>{{ inspection?.a_6_1?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.a_6_1?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{ getConclusion(inspection?.a_6_1) }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{ inspection?.a_6_2.section }}</span>
        </td>
        <td>
          <span>{{ inspection?.a_6_2?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.a_6_2?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{ getConclusion(inspection?.a_6_2) }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{ inspection?.a_8_1.section }}</span>
        </td>
        <td>
          <span>{{ inspection?.a_8_1?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.a_8_1?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{ getConclusion(inspection?.a_8_1) }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{ inspection?.a_8_2.section }}</span>
        </td>
        <td>
          <span>{{ inspection?.a_8_2?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.a_8_2?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{ getConclusion(inspection?.a_8_2) }}</span>
        </td>
      </tr>
      <tr>
        <td class="section">
          <span>{{ inspection?.a_8_3.section }}</span>
        </td>
        <td>
          <span>{{ inspection?.a_8_3?.title }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of inspection?.a_8_3?.notes
                | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
        <td>
          <span>{{ getConclusion(inspection?.a_8_3) }}</span>
        </td>
      </tr>
    </tbody>
  </table>

  <authority-labs-summary-notes
    [summaryNotes]="inspection?.summaryNotes"
    [root]="true"
  ></authority-labs-summary-notes>
</div>
